const validationTypes = {
  not_blank: (value, translatable, languages) => {
    const validation = v => v && v.length > 0
    if (translatable) {
      let valid = true
      let defaultlanguage = false
      Object.keys(languages).forEach((language, index) => {
        if (index === 0 && validation(value[language])) {
          defaultlanguage = true
        }
        if (!validation(value[language])) {
          valid = false
        }
      })
      if (defaultlanguage && !valid) valid = true
      return valid
    }
    return validation(value)
  },
  password: (value, translatable, languages, extraData) => {
    if (extraData.mode === 'edit' && value === '') return true
    return value && value === extraData.repeated
  },
  min_length: (value, translatable, languages, extraData) => {
    if (extraData.mode === 'edit' && value === '') return true
    return value && value.length > 5
  },
}

const Errors = (value, validations, translatable, languages, extraData = {}) => {
  const valid = []
  if (validations) {
    Object.keys(validations).forEach(validation => {
      if (
        typeof validationTypes[validation] !== 'undefined'
        && !validationTypes[validation](value, translatable, languages, extraData)
      ) {
        valid.push(validations[validation])
      }
    })
  }
  return valid
}

export default Errors
